import { createFleetApiInstanceWithToken, createUploadFileFleetApiInstanceWithToken } from '../util';

const asset = {
    fetchAssetList(params) {
        return createFleetApiInstanceWithToken().get('/assets', { params });
    },
    connectedDevices(formData) {
        return createUploadFileFleetApiInstanceWithToken().post('/assets/connected_devices', formData);
    },
};

export default asset;
